<div class="hints">
  <ng-content></ng-content>
</div>
